<template>
  <router-link
    :to="'/projects/' + item.slug"
    @click.native="toggleModal"
    class="full-width"
    data-toggle="collapse"
    data-target=".navbar-collapse.show"
  >
    <div class="card card-row shadow-dark-lg mb-6 full-width">
      <div class="row no-gutters">
        <div
          v-if="item.featured"
          :test="item.featured.file_name"
          class="col-12 col-md-6 bg-cover card-img-left organization-card"
          :style="{
            backgroundImage: `url(${
              $store.state.api_url +
              '/images/organizations/' +
              item.id +
              '/thumbnail_' +
              item.featured.file_name
            })`,
          }"
        >
          <div
            class="shape shape-right shape-fluid-y svg-shim text-white d-none d-md-block"
          >
            <svg
              viewBox="0 0 112 690"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M116 0H51v172C76 384 0 517 0 517v173h116V0z"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
        </div>
        <div
          v-else
          class="col-12 col-md-6 d-flex align-items-center justify-content-center overlay-primary organization-card"
        >
          <div class="d-none d-md-block d-flex text-center">
            <div class="">
              <i
                v-if="item.category && item.category != 0"
                :class="'fad fa-' + item.category.icon"
                class="text-primary fa-3x"
              ></i>
              <i v-else class="fad fa-info text-primary fa-3x"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="card-body py-3">
            <h3>{{ item.name }}</h3>
            <p
              v-if="item.excerpt != 0"
              class="mb-0 text-muted organization-text"
              v-html="item.excerpt"
            ></p>
          </div>
          <div class="card-meta">
            <hr class="card-meta-divider" />
            <h6
              class="text-uppercase text-muted mr-2 mb-0"
              v-if="item.category && item.category != 0"
            >
              <i :class="'fad fa-' + item.category.icon"></i>
              {{ item.category.name }}
            </h6>
            <h6 v-else class="text-uppercase text-muted mr-2 mb-0">
              <i class="fad fa-info"></i> General
            </h6>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import { EventBus } from "../event-bus.js";

export default {
  props: {
    item: {},
  },
  methods: {
    toggleModal() {
      EventBus.$emit("clearSearch");
      if (this.$store.state.showDonate) {
        this.$store.state.showDonate = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a:hover {
  text-decoration: none;
}
.icon-wrapper {
  width: 100%;
  background: #f1f1f1;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 120px;
}
.organization-card {
  height: 230px;
}
.organization-text {
  max-height: 240px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>